import { companyClient } from "api/api";

export const postAppointmentChecklistEntry = async (
  appointmentId: number,
  fkChecklistId: number,
  order?: number,
  label?: string
) => {
  const res = await companyClient({
    method: "POST",
    url: "/appointment-checklists/entries",
    data: { appointmentId, fk_checklist_id: fkChecklistId, order, label },
  });
  return res.data;
};

export const patchAppointmentChecklistEntry = async (
  appointmentId: number,
  entryId: number,
  body: { label: string; required: boolean | null; order?: number }
) => {
  const res = await companyClient({
    method: "PATCH",
    url: `/appointment-checklists/entries/${entryId}`,
    data: {
      appointmentId,
      label: body.label,
      required: body.required,
      order: body.order,
    },
  });
  return res.data;
};

export const deleteAppointmentChecklistEntry = async (
  appointmentId: number,
  entryId: number
) => {
  const res = await companyClient({
    method: "DELETE",
    url: `/appointment-checklists/entries/${entryId}`,
    params: { appointmentId },
  });
  return res.data;
};
